import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import '../Auth/LoginPage.css';

function RegisterPage() {
  const { register } = useAuth();
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password !== confirmPassword) {
      setError('رمز عبور و تکرار آن مطابقت ندارند');
      return;
    }

    setLoading(true);
    try {
      await register(email, password, fullName);
      window.location.href = '/';
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-header">
          <h1>📈 پنل مدیریت سرمایه</h1>
          <p>ایجاد حساب کاربری جدید</p>
        </div>

        {error && <div className="auth-error">{error}</div>}

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label>نام و نام خانوادگی</label>
            <input
              type="text"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              placeholder="مثال: علی محمدی"
            />
          </div>

          <div className="form-group">
            <label>ایمیل</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="example@email.com"
              required
              dir="ltr"
            />
          </div>

          <div className="form-group">
            <label>رمز عبور</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="حداقل ۸ کاراکتر"
              required
              minLength={8}
              dir="ltr"
            />
          </div>

          <div className="form-group">
            <label>تکرار رمز عبور</label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="تکرار رمز عبور"
              required
              minLength={8}
              dir="ltr"
            />
          </div>

          <button type="submit" className="auth-btn" disabled={loading}>
            {loading ? 'در حال ثبت نام...' : 'ثبت نام'}
          </button>
        </form>

        <div className="auth-links">
          <a href="/login">قبلاً ثبت نام کرده‌ام</a>
        </div>
      </div>
    </div>
  );
}

export default RegisterPage;